<div class="rss-layout-component-container scrollable-component-container">
  <div
    class="attribute-editor-component"
    rvSpinner="layout-rss-editor-loader"
    [rvShowSpinner]="spinner"
  >
    <div
      class="scrollable-component-settings te-scrollable-container rss-layout-component-settings"
    >
      <!-- RSS Feed Link -->
      <div class="attribute-editor-row">
        <div
          class="form-group has-feedback"
          [ngClass]="{
            'has-error': hasUrlError,
            'has-success': hasValidUrl,
            'has-w3c-validation-errors': hasW3cValidationErrors,
          }"
        >
          <label class="rss-layout-section-heading" for="te-layout-rss-feed"
            >RSS feed link</label
          >
          <div class="rss-feed-url-input">
            <input
              type="text"
              id="te-layout-rss-feed"
              class="form-control u_ellipsis"
              [(ngModel)]="feedUrl"
              placeholder="Enter the link to your RSS feed"
              [disabled]="spinner"
              (debounceEvent)="saveFeed()"
              [attr.aria-invalid]="hasUrlError || null"
              [attr.aria-describedby]="
                hasUrlError || hasW3cValidationErrors
                  ? 'te-layout-rss-feed-message'
                  : null
              "
            />
            <streamline-icon
              class="overlay-icon form-control-feedback"
              aria-hidden="true"
              name="{{ hasUrlError ? 'exclamation' : 'checkmark' }}"
              width="14"
              height="12"
            ></streamline-icon>
          </div>
          <p
            id="te-layout-rss-feed-message"
            class="help-block"
            [class.rss-w3c-validation-message]="hasW3cValidationErrors"
          >
            @switch (validationResult) {
              @case ('INVALID_URL') {
                <span
                  >Provide a URL to a valid RSS feed. If you need help email
                  <a target="_blank" href="mailto:support@risevision.com"
                    >support&#64;risevision.com</a
                  ></span
                >
              }
              @case ('UNAUTHORIZED') {
                <span
                  >RSS feeds that require authentication are not supported. If
                  you need help email
                  <a target="_blank" href="mailto:support@risevision.com"
                    >support&#64;risevision.com</a
                  ></span
                >
              }
              @case ('NON_FEED') {
                <span
                  >Provide a URL to a valid RSS feed. If you need help email
                  <a target="_blank" href="mailto:support@risevision.com"
                    >support&#64;risevision.com</a
                  >.</span
                >
              }
              @case ('NOT_FOUND') {
                <span
                  >Provide a URL to a valid RSS feed. If you need help email
                  <a target="_blank" href="mailto:support@risevision.com"
                    >support&#64;risevision.com</a
                  >.</span
                >
              }
              @case ('INVALID_FEED') {
                <span
                  >The feed you are using contains
                  <a
                    [href]="w3cValidationUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    >validation errors</a
                  >, which may prevent it from displaying correctly.

                  <br /><br />
                  If you need help email
                  <a target="_blank" href="mailto:support@risevision.com"
                    >support&#64;risevision.com</a
                  >.</span
                >
              }
            }
          </p>
        </div>
      </div>

      <!-- Choose Layout -->
      <div class="attribute-editor-row">
        <label id="layout-rss-layout-label">Choose Layout</label>
        <div class="form-group layout-selector">
          <div
            class="layout-container"
            role="radiogroup"
            aria-labelledby="layout-rss-layout-label"
          >
            <button
              #layoutOptionBtn
              type="button"
              class="layout-option"
              [ngClass]="{
                'layout-option--selected': layout === LayoutType.CARDS,
              }"
              (click)="setLayout(LayoutType.CARDS)"
              (keydown)="onLayoutKeydown($event, LayoutType.CARDS)"
              [attr.aria-checked]="layout === LayoutType.CARDS"
              [attr.tabindex]="layout === LayoutType.CARDS || !layout ? 0 : -1"
              role="radio"
            >
              <div class="layout-icon-container">
                <!-- Cards icon: 3 cards, coordinates from Figma node 7218:5833 -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 104 64"
                  fill="none"
                  overflow="visible"
                >
                  <defs>
                    <filter
                      id="card-shadow"
                      x="-30%"
                      y="-30%"
                      width="160%"
                      height="160%"
                    >
                      <feDropShadow
                        dx="0"
                        dy="2"
                        stdDeviation="3"
                        flood-color="#94A3B8"
                        flood-opacity="0.2"
                      />
                      <feDropShadow
                        dx="0"
                        dy="2"
                        stdDeviation="2"
                        flood-color="#94A3B8"
                        flood-opacity="0.2"
                      />
                    </filter>
                  </defs>
                  <!-- Card 1 -->
                  <rect
                    x="10"
                    y="13.13"
                    width="26.25"
                    height="36.75"
                    rx="2.625"
                    fill="white"
                    stroke="rgba(57,76,96,0.15)"
                    stroke-width="0.656"
                    filter="url(#card-shadow)"
                  />
                  <!-- Green header inset (white border simulated by card bg showing through 2.625px gap) -->
                  <rect
                    x="12.625"
                    y="15.755"
                    width="21"
                    height="10.5"
                    rx="2.625"
                    fill="#3BBF74"
                  />
                  <rect
                    x="12.62"
                    y="28.88"
                    width="13.125"
                    height="5.25"
                    rx="2.625"
                    fill="#E2E8F0"
                  />
                  <!-- Card 2 -->
                  <rect
                    x="38.87"
                    y="13.13"
                    width="26.25"
                    height="36.75"
                    rx="2.625"
                    fill="white"
                    stroke="rgba(57,76,96,0.15)"
                    stroke-width="0.656"
                    filter="url(#card-shadow)"
                  />
                  <rect
                    x="41.495"
                    y="15.755"
                    width="21"
                    height="10.5"
                    rx="2.625"
                    fill="#3BBF74"
                  />
                  <rect
                    x="41.5"
                    y="28.88"
                    width="13.125"
                    height="5.25"
                    rx="2.625"
                    fill="#E2E8F0"
                  />
                  <!-- Card 3 -->
                  <rect
                    x="67.75"
                    y="13.13"
                    width="26.25"
                    height="36.75"
                    rx="2.625"
                    fill="white"
                    stroke="rgba(57,76,96,0.15)"
                    stroke-width="0.656"
                    filter="url(#card-shadow)"
                  />
                  <rect
                    x="70.375"
                    y="15.755"
                    width="21"
                    height="10.5"
                    rx="2.625"
                    fill="#3BBF74"
                  />
                  <rect
                    x="70.38"
                    y="28.88"
                    width="13.125"
                    height="5.25"
                    rx="2.625"
                    fill="#E2E8F0"
                  />
                </svg>
              </div>
              <div class="layout-label">Cards</div>
            </button>

            <button
              #layoutOptionBtn
              type="button"
              class="layout-option"
              [ngClass]="{
                'layout-option--selected': layout === LayoutType.SINGLE,
              }"
              (click)="setLayout(LayoutType.SINGLE)"
              (keydown)="onLayoutKeydown($event, LayoutType.SINGLE)"
              [attr.aria-checked]="layout === LayoutType.SINGLE"
              [attr.tabindex]="layout === LayoutType.SINGLE ? 0 : -1"
              role="radio"
            >
              <div class="layout-icon-container">
                <!-- Single icon: card with drop shadow, coordinates from Figma node 7218:5850 -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 104 64"
                  fill="none"
                  overflow="visible"
                >
                  <defs>
                    <filter
                      id="single-card-shadow"
                      x="-30%"
                      y="-30%"
                      width="160%"
                      height="160%"
                    >
                      <feDropShadow
                        dx="0"
                        dy="2"
                        stdDeviation="3"
                        flood-color="#94A3B8"
                        flood-opacity="0.2"
                      />
                      <feDropShadow
                        dx="0"
                        dy="2"
                        stdDeviation="2"
                        flood-color="#94A3B8"
                        flood-opacity="0.2"
                      />
                    </filter>
                  </defs>
                  <!-- White backing layer (creates depth behind shadow) -->
                  <rect
                    x="20"
                    y="17.5"
                    width="64"
                    height="16"
                    rx="2"
                    fill="white"
                  />
                  <!-- Card with drop shadow -->
                  <rect
                    x="20"
                    y="17.5"
                    width="64"
                    height="28"
                    rx="2"
                    fill="white"
                    stroke="rgba(57,76,96,0.03)"
                    stroke-width="0.5"
                    filter="url(#single-card-shadow)"
                  />
                  <!-- Text bar -->
                  <rect
                    x="42"
                    y="22.5"
                    width="36"
                    height="4"
                    rx="2"
                    fill="#E2E8F0"
                  />
                  <!-- Green sidebar -->
                  <rect
                    x="23"
                    y="20.5"
                    width="16"
                    height="22"
                    rx="2"
                    fill="#3BBF74"
                  />
                </svg>
              </div>
              <div class="layout-label">Single</div>
            </button>

            <button
              #layoutOptionBtn
              type="button"
              class="layout-option"
              [ngClass]="{
                'layout-option--selected': layout === LayoutType.HEADLINE,
              }"
              (click)="setLayout(LayoutType.HEADLINE)"
              (keydown)="onLayoutKeydown($event, LayoutType.HEADLINE)"
              [attr.aria-checked]="layout === LayoutType.HEADLINE"
              [attr.tabindex]="layout === LayoutType.HEADLINE ? 0 : -1"
              role="radio"
            >
              <div class="layout-icon-container">
                <!-- Headline icon: 3 list rows, coordinates from Figma node 7218:8599 -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 104 64"
                  fill="none"
                  overflow="visible"
                >
                  <defs>
                    <filter
                      id="headline-row-shadow"
                      x="-20%"
                      y="-50%"
                      width="140%"
                      height="200%"
                    >
                      <feDropShadow
                        dx="0"
                        dy="2"
                        stdDeviation="3"
                        flood-color="#94A3B8"
                        flood-opacity="0.2"
                      />
                      <feDropShadow
                        dx="0"
                        dy="2"
                        stdDeviation="2"
                        flood-color="#94A3B8"
                        flood-opacity="0.2"
                      />
                    </filter>
                  </defs>
                  <!-- Row 1 -->
                  <rect
                    x="20"
                    y="10.5"
                    width="64"
                    height="13"
                    rx="2"
                    fill="white"
                    filter="url(#headline-row-shadow)"
                  />
                  <rect
                    x="23"
                    y="13.5"
                    width="12"
                    height="7"
                    rx="2"
                    fill="#3BBF74"
                  />
                  <rect
                    x="38"
                    y="15.5"
                    width="36"
                    height="4"
                    rx="2"
                    fill="#E2E8F0"
                  />
                  <!-- Row 2 -->
                  <rect
                    x="20"
                    y="25.5"
                    width="64"
                    height="13"
                    rx="2"
                    fill="white"
                    filter="url(#headline-row-shadow)"
                  />
                  <rect
                    x="23"
                    y="28.5"
                    width="12"
                    height="7"
                    rx="2"
                    fill="#3BBF74"
                  />
                  <rect
                    x="38"
                    y="30.5"
                    width="36"
                    height="4"
                    rx="2"
                    fill="#E2E8F0"
                  />
                  <!-- Row 3 -->
                  <rect
                    x="20"
                    y="40.5"
                    width="64"
                    height="13"
                    rx="2"
                    fill="white"
                    filter="url(#headline-row-shadow)"
                  />
                  <rect
                    x="23"
                    y="43.5"
                    width="12"
                    height="7"
                    rx="2"
                    fill="#3BBF74"
                  />
                  <rect
                    x="38"
                    y="45.5"
                    width="36"
                    height="4"
                    rx="2"
                    fill="#E2E8F0"
                  />
                </svg>
              </div>
              <div class="layout-label">Headline</div>
            </button>
          </div>
        </div>
      </div>

      <!-- Number of items to show -->
      <div class="attribute-editor-row">
        <div class="form-group">
          <div class="flex-row left-right-aligner">
            <label for="te-layout-rss-item-count">Max items in queue</label>
            <select
              id="te-layout-rss-item-count"
              name="te-layout-rss-item-count"
              class="form-control rss-layout-select"
              [(ngModel)]="itemCount"
              (change)="save()"
              aria-label="Max items in queue"
            >
              <option value="1">1</option>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
              <option value="25">25</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Slide duration (Single and Cards layouts share one stored value;
           only the label adapts to the selected layout) -->
      @if (layout === LayoutType.SINGLE || layout === LayoutType.CARDS) {
        <div class="attribute-editor-row">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <div class="flex-row left-right-aligner">
                  <label for="te-layout-rss-slide-duration">{{
                    layout === LayoutType.SINGLE
                      ? 'Show each item for'
                      : 'Slide duration'
                  }}</label>
                  <div class="input-group rss-layout-input-group">
                    <input
                      type="number"
                      id="te-layout-rss-slide-duration"
                      name="te-layout-rss-slide-duration"
                      class="form-control"
                      min="1"
                      [(ngModel)]="slideDuration"
                      (change)="save()"
                      [attr.aria-label]="
                        (layout === LayoutType.SINGLE
                          ? 'Show each item for'
                          : 'Slide duration') + ' (seconds)'
                      "
                    />
                    <span class="input-group-addon">Seconds</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      <!-- Scroll speed (Headline layout only) -->
      @if (layout === LayoutType.HEADLINE) {
        <div class="attribute-editor-row">
          <div class="form-group">
            <div class="flex-row left-right-aligner">
              <label for="te-layout-rss-scroll-speed">Scroll speed</label>
              <select
                id="te-layout-rss-scroll-speed"
                name="te-layout-rss-scroll-speed"
                class="form-control rss-layout-select"
                [(ngModel)]="scrollSpeed"
                (ngModelChange)="save()"
                aria-label="Scroll speed"
              >
                <option value="slow">Slow</option>
                <option value="medium">Medium</option>
                <option value="fast">Fast</option>
              </select>
            </div>
          </div>
        </div>
      }

      <!-- Content -->
      <div class="attribute-editor-row">
        <p class="rss-layout-section-heading">Content</p>
        <div class="flex-row left-right-aligner pt-3 form-group">
          <label id="layout-rss-show-images-label" class="mb-0 control-label"
            >Show images</label
          >
          <mat-slide-toggle
            class="pl-3"
            [checked]="showImages"
            (change)="showImages = $event.checked; save()"
            ariaLabelledby="layout-rss-show-images-label"
          ></mat-slide-toggle>
        </div>
        <div class="flex-row left-right-aligner pt-3 form-group">
          <label
            id="layout-rss-show-categories-label"
            class="mb-0 control-label"
            >Show categories</label
          >
          <mat-slide-toggle
            class="pl-3"
            [checked]="showCategories"
            (change)="showCategories = $event.checked; save()"
            ariaLabelledby="layout-rss-show-categories-label"
          ></mat-slide-toggle>
        </div>
        <div class="flex-row left-right-aligner pt-3 form-group">
          <label
            id="layout-rss-show-description-label"
            class="mb-0 control-label"
            >Show description</label
          >
          <mat-slide-toggle
            class="pl-3"
            [checked]="showDescription"
            (change)="showDescription = $event.checked; save()"
            ariaLabelledby="layout-rss-show-description-label"
          ></mat-slide-toggle>
        </div>
        <div class="flex-row left-right-aligner pt-3 form-group">
          <label
            id="layout-rss-show-publish-date-label"
            class="mb-0 control-label"
            >Show publish date</label
          >
          <mat-slide-toggle
            class="pl-3"
            [checked]="showPublishDate"
            (change)="showPublishDate = $event.checked; save()"
            ariaLabelledby="layout-rss-show-publish-date-label"
          ></mat-slide-toggle>
        </div>
      </div>

      <!-- Colors -->
      <div class="attribute-editor-row tw-mt-[20px]">
        <p class="rss-layout-section-heading">Colors</p>
        <div class="form-group">
          <div class="flex-row left-right-aligner pt-3">
            <span id="rss-color-label-text" class="rss-layout-color-label"
              >Text</span
            >
            <color-picker
              pickerId="te-layout-rss-text-color"
              ariaLabelledby="rss-color-label-text"
              [(ngModel)]="textColor"
              (change)="save()"
              ngDefaultControl
            ></color-picker>
          </div>
        </div>
        <div class="form-group">
          <div class="flex-row left-right-aligner pt-3">
            <span id="rss-color-label-accent" class="rss-layout-color-label"
              >Accent</span
            >
            <color-picker
              pickerId="te-layout-rss-accent-color"
              ariaLabelledby="rss-color-label-accent"
              [(ngModel)]="accentColor"
              (change)="save()"
              ngDefaultControl
            ></color-picker>
          </div>
        </div>
        <div class="form-group">
          <div class="flex-row left-right-aligner pt-3">
            <span id="rss-color-label-bg" class="rss-layout-color-label"
              >Background</span
            >
            <color-picker
              pickerId="te-layout-rss-bg-color"
              ariaLabelledby="rss-color-label-bg"
              [(ngModel)]="backgroundColor"
              (change)="save()"
              ngDefaultControl
            ></color-picker>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
